import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/analytics/')({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/analytics/inventory',
      search,
      replace: true,
    });
  },
});
